'use client';

import { useEffect } from 'react';

// Public: Locks body scroll when `locked` is true. Prevents background
// scrolling behind overlays like modals and mobile menus.
//
// Desktop uses `overflow: hidden` + `padding-right: scrollbarWidth` on <html>
// so content doesn't shift when the scrollbar disappears. Mobile uses the
// `position: fixed` trick because iOS Safari ignores overflow:hidden at root.
export function useLockBodyScroll(locked: boolean) {
  useEffect(() => {
    if (!locked) return;

    const isDesktop = window.matchMedia('(min-width: 1024px)').matches;

    if (isDesktop) {
      const html = document.documentElement;
      const prevOverflow = html.style.overflow;
      const prevPaddingRight = html.style.paddingRight;
      const scrollbarWidth = window.innerWidth - html.clientWidth;
      html.style.overflow = 'hidden';
      if (scrollbarWidth > 0) {
        html.style.paddingRight = `${scrollbarWidth}px`;
      }
      return () => {
        html.style.overflow = prevOverflow;
        html.style.paddingRight = prevPaddingRight;
      };
    }

    const scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = 'unset';
      window.scrollTo(0, scrollY);
    };
  }, [locked]);
}
